import axios, { AxiosPromise } from 'axios';
import {
  IGetGuestReservations,
  IGuestReservationParams,
  IUpdateGuestContactStatusReq,
} from '../models/guestReservation.model';

const uri = '/mgmt/guest-reservation';

export const getGuestReservations = (
  params: IGuestReservationParams,
): AxiosPromise<IGetGuestReservations> => {
  return axios.post(`${uri}/search`, params);
};

export const updateGuestContactStatus = (
  resvCode: number,
  data: IUpdateGuestContactStatusReq,
): AxiosPromise => {
  return axios.patch(`${uri}/${resvCode}/contact-status`, data);
};

export const cancelGuestReservation = (resvCode: number): AxiosPromise => {
  return axios.patch(`${uri}/${resvCode}/cancel`);
};
